<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main.vue'
import { store } from '../../state/store'
import router from '../index'
import TextTest from '../../components/text-test.vue'
import FooterComponent from '../../components/footer.vue'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, TextTest, FooterComponent },
  data() {
    return {
      state: store.state,
      updateValue: '',
    }
  },
  methods: {
    updateTestState(updateValue) {
      store.updateTestState(updateValue)
    },
    goToJobLookup() {
      router.push({ path: 'select-job-type' })
    },
    logFooterSecondary() {
      store.updateTestState('Secondary button pressed!')
    },
  },
}
</script>

<template>
  <Layout>
    <h1>Hello Brinks Tech</h1>
    <p>{{ state.test }}</p>
    <input v-model="updateValue" />
    <button class="btn btn-primary" @click="updateTestState(updateValue)"
      >Update test state</button
    >
    <TextTest></TextTest>
    <FooterComponent
      primary-btn-text="Job Lookup"
      :primary-btn-callback="goToJobLookup"
      secondary-btn-text="Secondary"
      :secondary-btn-callback="logFooterSecondary"
    ></FooterComponent>
  </Layout>
</template>
